/**
 * Path generation utilities for session folder paths
 */
/**
 * Extract project and category IDs from session data
 * Uses the session's own project/category fields with fallback defaults
 */
function getSessionPaths(session) {
    // Use session's actual project/category data if available
    const projectId = session.project || 'p_default';
    const categoryId = session.category || 'c_default';
    return { projectId, categoryId };
}
/**
 * Generate the full folder path for a session
 * @param session The session object
 * @returns Windows-style folder path to the session directory
 */
export function generateSessionFolderPath(session) {
    if (!session || !session.id) {
        throw new Error('Invalid session: missing session ID');
    }
    // If session has folderPath from backend, use it directly
    if (session.folderPath) {
        // Convert Unix path to Windows path format 
        // Backend provides: /mnt/c/Projects/Sparkconverse/backend/data/projects/p_UhD136/c_jOb209/s_IlG712
        // Convert to: C:\Projects\Sparkconverse\backend\data\projects\p_UhD136\c_jOb209\s_IlG712
        const windowsPath = session.folderPath
            .replace(/^\/mnt\/c\//, 'C:\\') // Convert /mnt/c/ to C:\
            .replace(/\//g, '\\'); // Convert all other / to \
        return windowsPath;
    }
    // Fallback: construct path from project/category names (legacy behavior)
    // Base path - you can adjust this if needed
    const basePath = 'C:\\Projects\\Sparkconverse\\backend\\data\\projects';
    // Get the correct project and category IDs from the session data
    const { projectId, categoryId } = getSessionPaths(session);
    // Build the full path
    const fullPath = `${basePath}\\${projectId}\\${categoryId}\\${session.id}\\`;
    return fullPath;
}
/**
 * Generate a shorter display path for toast messages
 * @param session The session object
 * @returns Shortened path for display
 */
export function generateSessionDisplayPath(session) {
    const fullPath = generateSessionFolderPath(session);
    // Return just the last 3 segments for display
    const parts = fullPath.split('\\');
    return `...\\${parts.slice(-4, -1).join('\\')}\\`;
}
